export default __webpack_public_path__ + "static/media/Female-1.9e8c63da.svg";